import { Col, Row, Card, Divider, Typography, Space, Button } from "antd";
import DonutChart from "../charts/donut_chart/view/DonutChart";
import Progress from "../Progress";
import { useColors } from "../colors/controller/Colors";
import { useState, useEffect } from "react";
const DonutProgress = ({
    DonutDataKey = "value",
    DonutData = [
        { name: 'Group A', value: 400 },
        { name: 'Group B', value: 300 },
        { name: 'Group C', value: 300 },
        { name: 'Group D', value: 200 },
        { name: 'Group E', value: 200 },
        { name: 'Group F', value: 200 },
    ],
    colorTheams = "morandi"

}) => {

    const [progressData, setProgressData] = useState([])
    const [colors, setColors] = useState([])
    const getProgressData = (data) => {
        let total = data.reduce((sum, i) => {
            return sum + (i[DonutDataKey])
        }, 0)

        let newProgressData = data.map((dataValue, index) => {
            return {
                title: dataValue?.name || "",
                color: colors[index % colors.length],
                persent: Math.round((dataValue[DonutDataKey] / total) * 100),
                AddAfter: `${dataValue[DonutDataKey]}`,
            }
        })
        return newProgressData
    }
    const getColor = (colorTheams) => {
        let theamColors = getTheamColors(colorTheams)
        setColors((pre)=>{
            return theamColors
        })
    }
    const {
        getTheamColors,
    } = useColors()

    useEffect(() => {
        getColor(colorTheams)
    }, [colorTheams])

    return (
        <Row gutter={[8, 8]} align={"middle"}>
            <Col span={10} >
                <div
                    style={{
                        height: "180px"
                    }}
                >
                    <DonutChart
                        dataKey={DonutDataKey ?? "value"}
                        data={DonutData}
                        showLegend={false}
                        fontSize="10px"
                        colorTheams ={colorTheams}

                    />
                </div>
            </Col>
            <Col span={14} >
                <Row>
                    {
                        getProgressData(DonutData).map((value) => {
                            return (
                                <Col span={24}>
                                    <Progress
                                        {...value}
                                    />
                                </Col>
                            )
                        })
                    }
                </Row>
            </Col>
        </Row>
    )
}

export { DonutProgress }